import { render, staticRenderFns } from "./ItemOverlay.vue?vue&type=template&id=528952b6&scoped=true"
import script from "./ItemOverlay.vue?vue&type=script&lang=js"
export * from "./ItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ItemOverlay.vue?vue&type=style&index=0&id=528952b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528952b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528952b6')) {
      api.createRecord('528952b6', component.options)
    } else {
      api.reload('528952b6', component.options)
    }
    module.hot.accept("./ItemOverlay.vue?vue&type=template&id=528952b6&scoped=true", function () {
      api.rerender('528952b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/browser/item-overlays/ItemOverlay.vue"
export default component.exports